(function(window){

	const $ = require('jquery');

	/**
	 * Renders an email address link in the current elements DOM node based
	 * on the data-email attribute value.
	 * @return {Void}
	 */
	const renderEmailElement = function() {
		var email = $(this).attr("data-email");
		if (!email)
			return;

		try {
			email = window.atob(email);
		} catch (e) {return;}

		if (!email)
			return;

		$(this).html('<a href="mailto:' + email + '">' + email + '</a>');
	};

	$(document).ready(function(){
		$("[data-email]").each(renderEmailElement);
	});

})(window);
